import { restClient } from 'libs/restClient';
import { downloadFile } from 'helpers/Uploads';
import * as actions from 'actions/types';

const agreementTemplate = 'LicenseAgreement_Template.pdf';

export function signAgreement(modelId) {
  const url = `/devicemodels/${modelId}/licenseagreements`;
  const payload = restClient
    .post(url)
    .then(response => {
      return response;
    })
    .catch(err => {
      return err;
    });

  return {
    type: actions.SIGN_AGREEMENT,
    payload
  };
}

export function downloadAgreement({ model, tn }) {
  // file name pattern: CBRSA00000_LicenseAgreement.pdf
  // e.g. CBRSA00345_LicenseAgreement.pdf
  const fileName = `${tn}_LicenseAgreement.pdf`;

  const url = `/devicemodels/${model.id}/licenseagreements?download=true`;
  const payload = restClient
    .get(url, { responseType: 'blob' })
    .then(response => {
      downloadFile(response.data, fileName);
      return response;
    })
    .catch(err => {
      return err;
    });

  return {
    type: actions.DOWNLOAD_SIGNED_AGREEMENT,
    payload
  };
}

export function downloadAgreementBlank(submitter = '', modelnumber = '') {
  const url = `/licenseagreements?download=true&submitter=${submitter}&devicemodelnumber=${modelnumber}`;
  const payload = restClient
    .get(url, { responseType: 'blob' })
    .then(response => {
      downloadFile(response.data, agreementTemplate);
      return response;
    })
    .catch(err => {
      return err;
    });

  return {
    type: actions.DOWNLOAD_AGREEMENT_BLANK,
    payload
  };
}

export function getAgreementInfo(modelId, callback) {
  const url = `/devicemodels/${modelId}/licenseagreements`;
  const payload = restClient
    .get(url)
    .then(response => {
      callback();
      return response;
    })
    .catch(err => {
      callback();
      return err;
    });

  return {
    type: actions.GET_AGREEMENT_INFO,
    payload
  };
}

export function cleanAgreementInfo() {
  return {
    type: actions.CLEAN_AGREEMENT_INFO,
    payload: null
  };
}



// WEBPACK FOOTER //
// ./src/actions/agreement.js